// An organisation's slug, written from its trade name (ADR-0046, F-HQ-02).
//
// HQ invites a café with its business name and its owner's email or phone; when HQ gives no slug, the
// server writes one from the name with this, and HQ's form shows the same one as the name is typed. One
// function, so the slug the form shows is the slug the server writes. It may come out shorter than a slug
// may be (`OrganizationSlugSchema` in the contract): check it before using it.
/** A slug from a trade name: `Playground Gaming` → `playground-gaming`; accents dropped, cut to 60. */
export function organizationSlugFrom(name) {
    return name
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60)
        .replace(/-+$/, '');
}
//# sourceMappingURL=slug.js.map